export const FILES_TYPES = {
    MOL: 'mol',
    NMRIUM: 'nmrium',
    JSON: 'json',
    DX: 'dx',
    JDX: 'jdx',
    JDF: 'jdf',
    ZIP: 'zip',
    NMREDATA: 'nmredata',
};
export const FILES_SIGNATURES = {
    ZIP: '504b0304',
};
function getFileSignature(fileArrayBuffer) {
    return Array.from(new Uint8Array(fileArrayBuffer).slice(0, 4), (byte) => byte.toString(16).padStart(2, '0')).join('');
}
async function loadFile(file, options = {}) {
    const { asBuffer = false } = options;
    const response = await fetch(file);
    checkStatus(response);
    const data = asBuffer ? response.arrayBuffer() : response.text();
    return data;
}
function checkStatus(response) {
    if (!response.ok) {
        throw new Error(`HTTP ${response.status} - ${response.statusText}`);
    }
    return response;
}
function getFileExtension(name) {
    return name.replace(/^.*\./, '').toLowerCase();
}
function getFileName(name) {
    return name.slice(0, Math.max(0, name.lastIndexOf('.')));
}
function extractFileMetaFromPath(path) {
    const meta = path.replace(/^.*[/\\]/, '').split('.');
    return { name: meta[0].toLowerCase(), extension: meta[1].toLowerCase() };
}
/**
 *
 * @param {Array<File>} acceptedFiles
 * @param {object} options
 * @param {boolean} options.asBuffer
 * @returns
 */
function loadFiles(acceptedFiles, options = {}) {
    return Promise.all([].map.call(acceptedFiles, (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('abort', (e) => reject(e));
            reader.addEventListener('error', (e) => reject(e));
            reader.addEventListener('load', () => {
                if (reader.result) {
                    const binary = reader.result;
                    const name = getFileName(file.name);
                    const extension = getFileExtension(file.name);
                    resolve({ binary, name, extension });
                }
            });
            if (options.asBuffer) {
                reader.readAsArrayBuffer(file);
            }
            else {
                reader.readAsBinaryString(file);
            }
        });
    }));
}
export { loadFiles, loadFile, getFileExtension, getFileName, extractFileMetaFromPath, getFileSignature, };
